export function shuffleArray<T>(arr: Array<T>): Array<T> {
  const new_arr = arr.slice();
  for (let j, x, i = arr.length; i; ) {
    j = Math.floor(Math.random() * i);
    x = new_arr[--i];
    new_arr[i] = new_arr[j];
    new_arr[j] = x;
  }
  return arr;
}
